import request from '../../utils/request';
import { Result } from '../../models/general';

/**
 * CO-923 — the company's single overtime approval workflow (`api/OvertimeWorkflows`, HrOnly).
 *
 * Hand-written like `overtimeApprovals.ts`: `src/models/*` is generated and must not be edited.
 * The v1 rules (shapes [Manager] / [Manager, HR] / [HR], escalate-to-HR only, 1-336 calendar hours)
 * are enforced by the server; the settings card's presets are a convenience, never the boundary.
 * A null payload from GET means "no workflow": today's routing (manager, else HR).
 */

export type OvertimeWorkflowApproverSource = 'Manager' | 'HR';

export interface OvertimeWorkflowStep {
  stepOrder: number;
  approverSource: OvertimeWorkflowApproverSource;
  /** Calendar hours before the step escalates to HR. */
  timeLimitHours: number;
}

export interface OvertimeWorkflow {
  id: number;
  name: string;
  steps: OvertimeWorkflowStep[];
}

export interface OvertimeWorkflowStepInput {
  approverSource: OvertimeWorkflowApproverSource;
  timeLimitHours: number;
}

/** Owner decision D2 (2026-10-21). */
export const OVERTIME_WORKFLOW_DEFAULT_HOURS = 48;
export const OVERTIME_WORKFLOW_MIN_HOURS = 1;
export const OVERTIME_WORKFLOW_MAX_HOURS = 336;

export async function getOvertimeWorkflow(): Promise<Result<OvertimeWorkflow | null>> {
  const response = await request.get<Result<OvertimeWorkflow | null>>('OvertimeWorkflows');
  return response.data;
}

export async function saveOvertimeWorkflow(
  steps: OvertimeWorkflowStepInput[],
): Promise<Result<OvertimeWorkflow | null>> {
  const response = await request.put<Result<OvertimeWorkflow | null>>('OvertimeWorkflows', { steps });
  return response.data;
}

export async function deleteOvertimeWorkflow(): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>('OvertimeWorkflows');
  return response.data;
}
